import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';
import consts from '../../libs/consts';

import * as APIS from "../../utils/service";
import Select from '../../component/Select';


export default function ApplicationList({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);
    const [memberinfos, setmemberinfos] = useState('');

    const [applicationlist, setapplicationlist] = useState([]);
    const levelText = ['', '중개보조원', '공인중개사', '대표공인중개사'];

    const [confirmModal, setconfirmModal] = useState(false);

    //정보 관련
    const [selectUser, setselectUser] = useState(null);
    const [ranks, setranks] = useState('직원');
    const [pay_type, setpay_type] = useState(1)
    const [work_type, setwork_type] = useState(1)
    const [pay, setpay] = useState(0)
    const [pay_per, setpay_per] = useState(50)


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        listopen();
    }, []);

    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/master/application', sender).then(({ data }) => {
            if (data) {
                console.log(data);
                setapplicationlist(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const resetInputData = () => {
        setranks("직원")
        setpay_type(1)
        setwork_type(1)
        setpay(0)
        setpay_per(50)
    }

    const applicationCancle = (uidx, statusflag) => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            idx: uidx,
            status: statusflag
        }

        if (statusflag) {
            sender.work_type = work_type;
            sender.pay_type = pay_type;
            sender.pay = pay;
            sender.pay_per = pay_per;
            sender.ranks = ranks;
        }

        APIS.postData('/v1/master/applicationAgree', sender).then(({ data }) => {
            if (data) {
                dispatch(
                    open({
                        component: statusflag ? '승인되었습니다.' : '거부되었습니다.',
                        title: '알림',
                        titleviewer: true,
                        alert: false,
                    })
                );
                listopen();
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    return (
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={3} />
                </div>
                <div className='padding32'>
                    <div className='pagetitle fontsize20 bolds'>소속신청 관리</div>
                    <div className='mypageinputsarea margint12'>

                        {applicationlist?.length > 0 && applicationlist?.map((x, i) => {
                            console.log("????", x);
                            return (
                                <div
                                    key={i}
                                    className='padding20'
                                    style={{
                                        border: '1px solid #DDD', borderRadius: 4, marginTop: 8,
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundImage: `${x?.user?.profile ? "url('" + consts.s3url + "/" + x?.user?.profile + "')" : "url('./images/icons/user-3-fill-small.svg')"}`,
                                                backgroundSize: `${x?.user?.profile ? "cover" : ""}`,
                                                width: 36, height: 36, border: '1px solid #EEE', borderRadius: 100, backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center'
                                            }}
                                        />

                                        <div className='bolds fontsize16'>{x?.user?.name}</div>
                                        <div className='color666 fontsize12'>{levelText[x?.user?.level]}</div>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                        }}
                                    >
                                        <div className='color666 fontsize12'>2024.05.06 신청</div>
                                        <Button
                                            disabled={true}
                                            onPress={() => {
                                                applicationCancle(x?.idx, false);
                                            }}
                                            styles={{
                                                fontSize: 12, fontWeight: 700, width: 45, height: 30,
                                                color: '#333'
                                            }}
                                            buttonTxt={'거부'}
                                        />
                                        <Button
                                            onPress={() => {
                                                resetInputData();
                                                setconfirmModal(true);
                                                setselectUser(x);
                                            }}
                                            styles={{
                                                fontSize: 12, fontWeight: 700, width: 45, height: 30,
                                            }}
                                            buttonTxt={'승인'}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                        {applicationlist?.length === 0 &&
                            <div className='nolistArea'>
                                신청된 내역이 없습니다.
                            </div>
                        }

                    </div>
                </div>
            </div>
            {confirmModal && <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG'
                    //onClick={() => { setupdatedatepop(false); }}
                    />
                    <div className='PopupAreaContents' style={{ width: 500 }}>
                        <div>
                            <div className="popTitle padding20">
                                <span >소속 신청</span>
                                <button
                                    onClick={() => {
                                        setconfirmModal(false)
                                        setselectUser(null)
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />
                                </button>
                            </div>
                            <div style={{ padding: 20 }} >
                                <p><b>신청자 정보</b></p>
                                <div class="inputtextviewtype1">
                                    <div>성함</div>
                                    <div>{selectUser?.user?.name}</div>
                                </div>
                                <div class="inputtextviewtype1">
                                    <div>회원유형</div>
                                    <div>{levelText[selectUser?.user?.level]}</div>
                                </div>
                                <div class="inputtextviewtype1">
                                    <div>연락처</div>
                                    <div>{selectUser?.user?.hp}</div>
                                </div>
                                <p style={{ marginTop: 16 }}><b>정보 설정</b></p>
                                <div class="inputtextviewtype1">
                                    <div>급여조건</div>
                                    <div>
                                        <Select
                                            setValues={v => { setpay_type(v * 1) }}
                                            values={pay_type}
                                            selectData={configdata?.consts?.memberPayType?.map(v => ({ labels: v?.title, values: v?.idx }))}
                                        />
                                    </div>
                                </div>
                                <div class="inputtextviewtype1">
                                    <div>근로형태</div>
                                    <div>
                                        <Select
                                            setValues={v => { setwork_type(v * 1) }}
                                            values={work_type}
                                            selectData={configdata?.consts?.memberWorkType?.map(v => ({ labels: v?.title, values: v?.idx }))}
                                        />
                                    </div>
                                </div>
                                <div class="inputtextviewtype1">
                                    <div>기본급</div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            setValue={v => {
                                                setpay(Math.floor(v))
                                            }}
                                            value={pay}
                                            valid={"num"}
                                            rightplaceholder="원"
                                        />
                                    </div>
                                </div>
                                <div class="inputtextviewtype1">
                                    <div>비율</div>
                                    <div>
                                        <Input
                                            className={`inputs`}
                                            setValue={v => {
                                                if (v > 100) {
                                                    setpay_per(100)
                                                } else {
                                                    setpay_per(Math.floor(v))
                                                }
                                            }}
                                            value={pay_per}
                                            valid={"num"}
                                            rightplaceholder="%"
                                        />
                                    </div>
                                </div>
                                <div class="inputtextviewtype1">
                                    <div>직함</div>
                                    <div>
                                        <Input
                                            placeholder="숫자/띄어쓰기 없이 입력"
                                            className={`inputs`}
                                            setValue={v => {
                                                if (/^[^0-9]*$/.test(v)) {
                                                    setranks(v.replace(" ", ""))
                                                }
                                            }}
                                            value={ranks}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='popbuttons' style={{ marginTop: 0, padding: 20, paddingTop: 0 }}>
                                <div>
                                    <Button
                                        buttonTxt={'소속 수락'}
                                        onPress={() => {
                                            applicationCancle(selectUser?.idx, true);
                                            setconfirmModal(false)
                                        }}
                                    />
                                </div>
                                <div>
                                    <Button
                                        disabled={true}
                                        buttonTxt={'거절'}
                                        onPress={() => {
                                            applicationCancle(selectUser?.idx, false);
                                            setconfirmModal(false)
                                            setselectUser(null)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </Layout>
    )
}

